import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/navbar/navbar';
import Hero from './components/hero/hero';
import About from './components/about/about';
import Services from './components/services/services';
import Contact from './components/contact/contact';
import Testimonial from './testimonials/testimonials';
import WetBasementService from './components/services/service/wetBasement';
import MouldRemediation from './components/services/service/mouldRemediation';
import FoundationRepair from './components/services/service/foundationRepair';
import InteriorDrainage from './components/services/service/interiorDrainage';
import BackwaterValve from './components/services/service/backwaterValve';
import CornerFoundation from './components/services/service/cornerFoundation';
import Footer from './components/footer/footer';
import Announcement from './components/navbar/announcement';
import NotFound from './components/NotFound';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes className="">
        <Route path="/" element={<><Hero /><About /><Services /><Testimonial /><Contact /></>} />
        <Route path="/services/crack-repair" element={<FoundationRepair />} />
        <Route path="/services/wet-basement" element={<WetBasementService />} />
        <Route path="/services/interior-drainage" element={<InteriorDrainage />} />
        <Route path="/services/mould-remediation" element={<MouldRemediation />} />
        <Route path="/services/backwater-valve" element={<BackwaterValve />} />
        <Route path="/services/corner-foundation-repair" element={<CornerFoundation />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Announcement />
      <Footer />
    </Router>


  );
}

export default App;
